import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { connectDeep } from 'redux-utils';

import ContinueInstallModal, {
  dispatchToProps as installDispatch,
  stateToProps as installState
} from './ContinueInstallModal';
import ErrorModal, {
  dispatchToProps as errorDispatch,
  stateToProps as errorState
} from './ErrorModal';

interface ErrorDispatchType {
  removeError: () => void;
}

export interface TriggerSyncType {
  requiresWifi: boolean
  continueInstall?: ContinueInstallType
}

interface InstallDispatchType {
  triggerSync: (args: TriggerSyncType) => void
  triggerRemove: () => void
}

interface InstallType {
  installFlow: InstallFlowType
  continueInstall: ContinueInstallType
}

interface ModalSwitcherProps extends ReduxProps {
  errorDispatch: ErrorDispatchType
  installDispatch: InstallDispatchType
  install: InstallType
}

const ModalSwitcher: FC<ModalSwitcherProps> = ({ error, errorDispatch, install, installDispatch }) => {
  if (
    error &&
    ((error.message && error.title) || (error.messageKey && error.titleKey))
  ) {
    return <ErrorModal error={error} {...errorDispatch} />;
  } else if (install?.continueInstall?.show) {
    return <ContinueInstallModal {...install} {...installDispatch} />;
  }
  return <div />;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface TriggerErrorType {
  message: string
  title: string
}

export interface InstallFlowType {
  requiresWifi: boolean
  continueInstall: ContinueInstallType
}

export interface ContinueInstallType {
  show: boolean
  hasBeenSeen: boolean
  shouldContinue: boolean
}

const mapStateToProps = ({
  gallery: { triggerError },
  installFlow: { continueInstall, requiresWifi }
}: { 
  gallery: { triggerError: TriggerErrorType },
  installFlow: InstallFlowType
}) => ({
  ...errorState({ triggerError }),
  install: {
    ...installState({ continueInstall, requiresWifi })
  }
});

const mapDispatchToProps = (dispatch: any) => ({
  errorDispatch: {
    ...errorDispatch(dispatch)
  },
  installDispatch: {
    ...installDispatch(dispatch)
  }
});

export default connectDeep(mapStateToProps, mapDispatchToProps)(ModalSwitcher);
